import { render } from "./LibrariesEdit.vue?vue&type=template&id=3e6a52fe"
import script from "./LibrariesEdit.vue?vue&type=script&lang=js"
export * from "./LibrariesEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__